import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import { invariant } from './invariant.js';

/**
 * Tranform common props to properties for use with a HTMLElement.
 */
/* eslint-disable-next-line @typescript-eslint/ban-types */
var applyCommonProps = function applyCommonProps(props, Component) {
  var isAriaLabelBanned = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var componentName = Component.displayName || Component.name || 'Unknown';

  /* istanbul ignore if */
  if (process.env.NODE_ENV !== 'production') {
    /*
     * `@walmart-web/livingdesign-components` is used as a package outside glass wherein the
     * consumers might not have typecheck enabled. The below checks are to ensure `className`
     * and `style` are not mistakenly passed in props.
     */

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (props.className) {
      /* eslint-disable-next-line no-console */
      console.error("".concat(componentName, ".className property has been deprecated. Please use the \"UNSAFE_className\" property."));
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (props.style) {
      /* eslint-disable-next-line no-console */
      console.error("".concat(componentName, ".style property has been deprecated. Please use the \"UNSAFE_style\" property."));
    }
  }
  if (isAriaLabelBanned) {
    invariant(props['aria-label'] === undefined, "`".concat(componentName, "` accessibility violation. `").concat(componentName, "` is banned from using `aria-label`."));
  }
  var appliedProps = {};
  for (var key in props) {
    // eslint-disable-next-line no-prototype-builtins
    if (props.hasOwnProperty(key)) {
      var value = props[key];
      if (key === 'UNSAFE_className') {
        appliedProps.className = classNames(appliedProps.className, value);
      } else if (key === 'UNSAFE_style') {
        appliedProps.style = appliedProps.style ? _objectSpread2(_objectSpread2({}, appliedProps.style), value) : value;
      } else if (key !== 'className' && key !== 'style') {
        appliedProps[key] = value;
      }
    }
  }
  return appliedProps;
};

export { applyCommonProps };
